import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import {
  Navigate, Route, Routes,
} from 'react-router-dom';
import { Confirmation } from './components/confirmation/Confirmation';
import { CustomerLogin } from './components/customer';
import { RatePlan } from './components/rate';
import { FeatureContext } from './FeatureContext';
import { IAppReduxState, ICoreReduxState } from './models';
import { Congratulations } from './components/congratulations/Congratulations';
import { TestingDashboard } from './components/dashboard';
import { TestingDashboardLogin } from './components/dashboard/TestingDashboardLogin';

export default function AppRoute() {
  const featureContext = useContext(FeatureContext);
  const { isAuthenticated, isTestingDashboardAuthenticated } = useSelector<IAppReduxState, ICoreReduxState>((x) => x.core);

  if (!isAuthenticated && !isTestingDashboardAuthenticated) {
    return (
      <Routes>
        <Route path="*" element={<Navigate to="/login" />} />
        <Route path="/login" element={<CustomerLogin />} />
        <Route path="/testingdashboard/login" element={featureContext.TESTING_DASHBOARD && <TestingDashboardLogin />} />
        <Route path="/testingdashboard" element={<Navigate to="/testingdashboard/login" />} />
      </Routes>
    );
  }

  if (isTestingDashboardAuthenticated) {
    return (
      <Routes>
        <Route path="*" element={<Navigate to="/testingdashboard" />} />
        <Route path="/testingdashboard" element={featureContext.TESTING_DASHBOARD && <TestingDashboard />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="*" element={<Navigate to="/plans" />} />
      <Route path="/plans" element={<RatePlan />} />
      <Route path="/confirmation" element={<Confirmation />} />
      <Route path="/congratulations" element={<Congratulations />} />
    </Routes>
  );
}
